import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ShippingDiscountFragment = { id: string, pk: number, name: string, discountType: Types.DiscountTypeEnum, isCurrent: boolean, minValue: number, maxValue: number, value: number, shippingMethods: { id: string, pk: number, name: string } };

export const ShippingDiscountFragmentDoc = gql`
    fragment ShippingDiscountFragment on ShippingDiscountType {
  id
  pk
  name
  discountType
  isCurrent
  minValue
  maxValue
  value
  shippingMethods {
    id
    pk
    name
  }
}
    `;